var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"whiteboard"},[_c('vue-p5',{staticClass:"whiteboard__p5-canvas",attrs:{"id":_vm.WHITEBOARD_ID},on:{"setup":_vm.setup,"mousedragged":_vm.draw}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }